import React from 'react';
import { reduxForm } from 'redux-form';
import FormField from '../form/form-field';
import TextField from '../form/text-field';
import BaseForm from '../form/base-form';
import Button from '../button';
import { validateRequiredFields } from '../../utils/form';
import LocalizedStrings from '../../localization/strings';
import Alert from '../alert';


const fields = ['id', 'title_lt', 'title_en', 'body_lt', 'body_en', 'show_in_footer', 'order'];


function validate(values) {
  let errors = {
    _error: null
  };
  errors = validateRequiredFields(values, [
    'title_lt', 'title_en'
  ], errors);
  return errors;
}

class PageForm extends BaseForm {

  render() {
    const {
      submitting,
      error,
      handleSubmit,
      fields: {
        title_lt,
        title_en,
        body_lt,
        body_en,
        show_in_footer,
        order
      }
    } = this.props;
    return (
      <div>
        <form onSubmit={handleSubmit(this.submit.bind(this))}>
          {error && <Alert type="error">{error}</Alert>}
          <fieldset>
            <legend>{LocalizedStrings.ltLabel}</legend>
            <FormField label={LocalizedStrings.title} name="title" field={title_lt}>
              <input ref="title" className="border-full larger" placeholder={LocalizedStrings.title}
                     type="text" {...title_lt} />
            </FormField>

            <FormField label={LocalizedStrings.body} name="body" field={body_lt}>
              <TextField {...body_lt}></TextField>
            </FormField>


          </fieldset>
          <fieldset>
            <legend>{LocalizedStrings.enLabel}</legend>
            <FormField label={LocalizedStrings.title} name="title" field={title_en}>
              <input ref="title" className="border-full larger" placeholder={LocalizedStrings.title}
                     type="text" {...title_en} />
            </FormField>

            <FormField label={LocalizedStrings.body} name="body" field={body_en}>
              <TextField {...body_en}></TextField>
            </FormField>


          </fieldset>


          <FormField label={LocalizedStrings.showInFooter} name="billing_is_company" field={show_in_footer}
                     className="checkbox-field"
                     dots={false}>
            <input type="checkbox" {...show_in_footer} />
          </FormField>

          <FormField label={LocalizedStrings.order} name="order" field={order}>
            <input ref="link" className="border-full larger" placeholder={LocalizedStrings.order}
                   type="number" {...order} />
          </FormField>

          <div className="actions-row">

            <Button loading={submitting} submit={true} disabled={submitting} type="primary">
              {LocalizedStrings.submit}
            </Button>

          </div>

        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'page-form',
  fields,
  validate,
  destroyOnUnmount: true
}, state => ({
  initialValues: {
    show_in_footer: false,
    order: 0,
    ...state.page.page.item
  }
}))(PageForm);



// WEBPACK FOOTER //
// ./src/js/components/page/page-form.js